import outbro_logo from '../assets/company_logos/outbro_logo.webp';
import suhana_logo from '../assets/company_logos/suhana_logo.webp';
import techstax_logo from '../assets/company_logos/techstax_logo.webp';

export const experiences = [
    {
        logo: techstax_logo,
        logoAlt: 'TechStax Logo',
        role: 'Full Stack Engineer (Intern)',
        company: 'TechStax | Remote',
        duration: 'Jul 2025 – Jan 2026',
        bullets: [
            'Developed and deployed FastAPI/Flask microservices powering AI-driven automation workflows, including webhook ingestion and background processing.',
            'Integrated LLM-based agent systems with prompt optimization and caching to reduce manual operations and improve system throughput.',
            'Collaborated in Agile sprints, code reviews, and CI/CD deployments using Docker and Linux to ship scalable backend features.',
        ],
        tech: [
            'Python', 'FastAPI', 'Flask', 'Docker', 'CI/CD', 'Linux', 'LLM Integration',
            'LangChain', 'Function Calling', 'FAISS', 'Hugging Face', 'Ollama',
            'Celery', 'Webhooks', 'Prompt Engineering', 'Redis', 'n8n', 'MCP',
            'RAG', 'Automation Testing', 'Manual Testing'
        ]
    },
    {
        logo: outbro_logo,
        logoAlt: 'Outbro Logo',
        role: 'Website Manager & Full-Stack Developer',
        company: 'Outbro | Remote',
        duration: 'Nov 2023 – Jun 2025',
        bullets: [
            'Delivered and maintained Outbro\'s full-stack platform using React.js, Node.js, Express, and MongoDB, serving 100+ users monthly.',
            'Developed RESTful APIs, implemented JWT-based authentication, and integrated Socket.io for real-time chat.',
            'Improved frontend performance by 25% through code splitting, lazy loading, and mobile-first optimization.',
            'Coordinated with design and product teams to plan UX improvements aligned with business goals.',
        ],
        tech: [
            'React.js', 'Node.js', 'Express.js', 'MongoDB', 'Netlify', 'Render',
            'JWT', 'Socket.io', 'REST API', 'Python', 'Machine Learning',
            'Microservices', 'Performance Optimization', 'Agile/Scrum',
            'AI Recommendation Systems', 'Vector Database', 'RAG', 'LLM',
            'Prompt Engineering'
        ]
    },
    {
        logo: suhana_logo,
        logoAlt: 'Suhanasoftech Logo',
        role: 'MERN Stack Developer (Part-Time)',
        company: 'Suhanasoftech | Kolkata, India',
        duration: 'Sep 2022 - Oct 2023',
        bullets: [
            'Designed and built full-stack web applications using the MERN stack (MongoDB, Express.js, React.js, Node.js).',
            'Produced modular MERN stack web apps with reusable React components and robust REST API integrations.',
            'Integrated third-party libraries and APIs, enhanced code efficiency, and contributed to agile project delivery.',
            'Enhanced code quality through unit testing, documentation, and Git version control.',
        ],
        tech: ['MongoDB', 'Express.js', 'React.js', 'Node.js', 'REST API', 'Git']
    }
];
